import {
	Button,
	Card,
	CardContent,
	CardDescription,
	CardTitle,
	cn,
} from "@babybjorn/ui";
import type { StoryblokRichTextNode } from "@storyblok/react";
import type { FC, HTMLAttributes, ReactElement } from "react";
import Icon from "../../../general/Icon/Icon";
import ImageContainer from "../../../general/ImageContainers/ImageContainer";
import Link from "../../../general/Link";
import RichText from "../../../general/RichText/RichText";

type ThreeUpItemProps = HTMLAttributes<HTMLDivElement> & {
	image: { alt: string | null; filename: string | null } | undefined | null;
	headline: string;
	href?: string;
	text?: StoryblokRichTextNode<ReactElement>;
	cta?: { label: string; href: string; target?: string; icon?: string };
};

const ThreeUpItem: FC<ThreeUpItemProps> = ({
	image,
	headline,
	text,
	cta,
	href,
}) => {
	return (
		<Card variant="square" className="gap-y-4 lg:gap-y-6">
			<Link href={href}>
				<ImageContainer
					alt={image?.alt ?? undefined}
					imgSrc={image?.filename ?? ""}
					objectFit="cover"
				/>
			</Link>

			<CardContent className="border-inherit p-0 lg:p-0">
				<CardTitle>{headline}</CardTitle>
				<CardDescription className="space-y-4 lg:space-y-6">
					<RichText content={text} />
					{cta && (
						<div className="flex w-auto">
							<Button
								variant="secondary"
								asChild
								className={cn({
									"min-w-fit": cta.icon && !cta.label,
									"max-w-fit": cta.label,
								})}
								size={cta.icon && !cta.label ? "icon" : "default"}
							>
								<Link href={cta.href}>
									{cta.icon && <Icon icon={cta.icon} color="inherit" />}
									{cta.label && <span>{cta.label}</span>}
									<span className="sr-only">Link</span>
								</Link>
							</Button>
						</div>
					)}
				</CardDescription>
			</CardContent>
		</Card>
	);
};

export default ThreeUpItem;
